/**
 * This implementation repackages a minimal API based on a heavily outdated version of react-toast.  We plan to swap/update the internal implementation after the app is fully using the `eds.useToast` solution.
 * https://github.com/fkhadra/react-toastify/tree/v4.5.2
 */
import {
  toast as vendorToast,
  ToastContainer as VendorToastContainer,
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { showToast } from '../Toast/showToast';

export const useToast = () => {
  /**
   * API to programmatically dismiss a toast.  Use this sparingly and rely more on the `toast` API to manage the toast instance.
   * - When called without arguments, will dismiss all toasts.
   * - When called with a specific argument (toastId), will dismiss the specific toast.  Consumers are required to track/manage toastIds returned from the `toast` API
   *
   * @example
   * ```js
   * const { dismiss, toast } = useToast();
   * const toastId = toast(...);
   *
   * dismiss(toastId); // dismisses just the specified toast
   * dismiss(); // dismisses all toasts
   * ```
   */
  const dismiss = vendorToast.dismiss;
  const isActive = vendorToast.isActive;

  return {
    dismiss,
    isActive,
    toast: showToast,
    ToastContainer,
  };
};

const ToastContainer = () => <VendorToastContainer />; // intentionally NOT configurable (to aid safe migration)
